<template>
    <div class="slider-wrapper">
        <div
            class="arrow arrow-left"
            @click="prevHandler"
            :style="{ opacity: isPrev ? 1 : 0 }"
        ></div>
        <div class="content-wrapper" ref="sliderWrapper">
            <div class="content" :style="{ left: itemWidth * currentIndex + 'px' }">
                <slot></slot>
            </div>
        </div>
        <div
            class="arrow arrow-right"
            @click="nextHandler"
            :style="{ opacity: isNext ? 1 : 0 }"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'Slider',
    data: ()=>({
        currentIndex: 0,
        isNext: true,
        isPrev: true,
    }),
    props: {
        itemWidth: Number,
        itemsCount: Number,
    },
    computed: {
    },
    methods: {
        prevHandler() {
            if (this.prev()) return;
            this.currentIndex += 1;
            this.checkControls();
        },
        nextHandler() {
            if(this.next()) return;
            this.currentIndex -= 1;
            this.checkControls();
        },
        vCount() {
            return this.$refs.sliderWrapper.offsetWidth / this.itemWidth;
        },
        next() {
            return (-this.currentIndex) + this.vCount()  >= this.itemsCount;
        },
        prev() {
            return (-this.currentIndex) <= 0;
        },
        checkControls() {
            this.isNext = !this.next();
            this.isPrev = !this.prev();
        },
    },

    watch: {
        '$refs.sliderWrapper.offsetWidth'(newV) {
            console.log(newV);
        },
    },
    mounted() {
        this.checkControls();
    },
};
</script>

<style lang="scss" scoped>
.slider-wrapper{
    width: 100%;
    display: flex;
    flex-direction: row;
    .arrow{
        width: 13px;
        cursor: pointer;
        opacity: 1;
        margin-left: 12px;
        margin-right: 12px;
        margin-top: 66px;
    }
    .arrow-left{
        background-image: url("../../../../../assets/images/account-track/icon/chevron-left.svg");
        background-repeat: no-repeat;
        background-position: center center;
        &:hover{
            background-image: url("../../../../../assets/images/account-track/icon/chevron-left-active.svg");
        }
    }
    .arrow-right{
        background-image: url("../../../../../assets/images/account-track/icon/chevron-right.svg");
        background-repeat: no-repeat;
        background-position: center center;
        &:hover{
            background-image: url("../../../../../assets/images/account-track/icon/chevron-right-active.svg");
        }
    }
    .content-wrapper{
        flex: 1;
        position: relative;
        overflow: hidden;
        .content{
            position: absolute;
            height: 100%;
            min-width: 100%;
        }

    }
}
</style>